module.exports = __webpack_public_path__ + "static/media/add-friend.73ba1e6a.svg";